export default __webpack_public_path__ + "locales/az/ChangeUserStatusDialog.json?hash=593bf835dcee28d7a33216b901db92fb";